import React, { useEffect, useState } from 'react';
import { object, string } from 'yup';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { LoginByCode } from '@jwp/ott-common/src/services/integrations/CustomAccountService';
import useForm from '@jwp/ott-hooks-react/src/useForm';
import { createURLFromLocation } from '@jwp/ott-ui-react/src/utils/location';
import type { ValidateQRLoginFormData } from '@jwp/ott-common/types/account';
import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';
// import { getModule } from '@jwp/ott-common/src/modules/container';
// import AccountController from '@jwp/ott-common/src/controllers/AccountController';
import { Auth } from 'aws-amplify';

import ValidateQRLoginForm from '../../../components/ValidateQRLoginForm/ValidateQRLoginForm';
import LoadingOverlay from '../../../components/LoadingOverlay/LoadingOverlay';
import { getModule } from '@jwp/ott-common/src/modules/container';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';

type Props = {
  messageKey: string | null;
};

const ValidateQRLogin: React.FC<Props> = ({ messageKey }: Props) => {
  const [isQrRedirection, setIsQrRedirection] = useState(true);
  const { siteName } = useConfigStore((s) => s.config);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('account');
  const { isCognitoEnabled, isCustomApiEnabled, isCleeng } = useAppConfig();
  const accountController = getModule(AccountController);

  const { values, errors, submitting, validationSchemaError, handleSubmit, handleChange } = useForm<ValidateQRLoginFormData>({
    initialValues: { QrCode: '' },
    validationSchema: object().shape({
      QrCode: string().required(t('login.qr_code', { field: t('login.qr_code') })),
    }),
    onSubmit: async ({ QrCode }) => {
      if (isCleeng) {
        const response = await accountController.qrAccessValidate(QrCode.toUpperCase(),t);
        if (response) {
          navigate('/');
        }
      }
      if (isCustomApiEnabled) {
        const response = await LoginByCode(QrCode.toUpperCase());
        if (response) {
          navigate('/');
        }
      }

      localStorage.setItem('otpVerification', JSON.stringify(true));
    },
    onSubmitError: ({ resetValue }) => {
      navigate(createURLFromLocation(location, { code: null }));
      resetValue('QrCode');
    },
  });

  const checkAuthStatus = async () => {
    const user = localStorage.getItem('jwapp.auth') || localStorage.getItem('access_token') || localStorage.getItem('inplayer_token');
    if (!user) {
      localStorage.setItem('otpVerification', JSON.stringify(false));
      if (isCognitoEnabled) {
        handleSignIn();
      } else {
        navigate(`/?u=create-account&qr=true`);
      }
    }
    if (user) {
      setIsQrRedirection(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      checkAuthStatus();
    }, 3000);
  }, []);

  const handleSignIn = async () => {
    if (isCognitoEnabled) {
      try {
        await Auth.federatedSignIn();
        setTimeout(() => {
          setIsQrRedirection(false);
        }, 2000);
      } catch (error) {
        console.error('Error signing in', error);
      }
    }
  };

  return isQrRedirection ? (
    <div style={{ height: 300 }}>
      <LoadingOverlay transparentBackground inline />
    </div>
  ) : (
    <ValidateQRLoginForm
      values={values}
      validationError={validationSchemaError}
      errors={errors}
      submitting={submitting}
      siteName={siteName}
      messageKey={messageKey}
      onSubmit={handleSubmit}
      onChange={handleChange}
      isQrRedirection={isQrRedirection}
    />
  );
};

export default ValidateQRLogin;
